import Backend from 'App/Dataman-Backend';
import { apiPut } from './http';
import {
  CAT_PRODUCTS,
  CAT_COMPANIES,
  CAT_NEWS,
  CAT_BRANDS,
  CAT_EVENTS,
  CAT_PATENT_RESEARCH,
  CAT_VARIATIONS,
} from 'App/utils/Collections';

const {
  apiUrlProductImages,
  apiUrlCompanyImages,
  apiUrlNewsImages,
  apiUrlBrandImages,
  apiUrlEventImages,
  apiPatentResearchImages,
  apiUrlProductVariationImages,
  apiFiles,
} = Backend.config;

export function isFile(value) {
  return value instanceof File;
}

export function getCatImagesUrl(category) {
  return {
    [CAT_PRODUCTS]: apiUrlProductImages,
    [CAT_COMPANIES]: apiUrlCompanyImages,
    [CAT_NEWS]: apiUrlNewsImages,
    [CAT_BRANDS]: apiUrlBrandImages,
    [CAT_EVENTS]: apiUrlEventImages,
    [CAT_PATENT_RESEARCH]: apiPatentResearchImages,
    [CAT_VARIATIONS]: apiUrlProductVariationImages,
  }[category];
}

export async function saveImageFile(url, value, params) {
  const data = new FormData();
  data.append('file', value);
  return Backend.post({
    url,
    params,
    headers: { 'content-type': 'multipart/form-data' },
    data,
  });
}

export function saveImageLink(url, value, params) {
  const data = JSON.stringify({ link: value });
  return Backend.post({
    url,
    params,
    headers: { 'content-type': 'application/json' },
    data,
  });
}

export async function createImage(category, value, params) {
  const url = getCatImagesUrl(category);
  if (!url) {
    throw new Error('Invalid category');
  }
  if (isFile(value)) {
    return saveImageFile(url, value, params);
  } else {
    return saveImageLink(url, value, params);
  }
}

export async function updateImage(category, id, data, params) {
  const url = getCatImagesUrl(category);
  if (!url) {
    throw new Error('Invalid category');
  }
  return apiPut(`${url}/${id}`, { data, params });
}

export async function uploadFile(data) {
  const formData = new FormData();
  for (const [key, val] of Object.entries(data)) {
    formData.set(key, val);
  }
  return Backend.post({
    url: apiFiles,
    headers: {
      'Content-type': 'multipart/form-data',
    },
    data: formData,
  });
}

export async function uploadImages(category, images, params) {
  if (images?.length) {
    return Promise.all(
      images.map((image) => {
        const { types, isNew, isDefault, value, data, isDirty } = image;
        const queryParams = { ...params };
        if (category === CAT_NEWS) {
          queryParams.intro = data?.intro;
        } else {
          queryParams.is_default = isDefault;
        }
        if (isNew) {
          return createImage(category, value, queryParams)
            .then((res) => {
              if (res.status === 201) {
                if (types && types.length) {
                  return updateImage(category, res.data.id, { types });
                }
              }
              return res;
            })
            .catch();
        } else if (isDirty) {
          if (category === CAT_NEWS) {
            return;
          }
          return updateImage(category, image.id, { default: isDefault, types });
        }
      })
    );
  }
}
